import React from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner, Alert, Image, Accordion, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ShapeDivider from './ShapeDivider';
const TemplateVideoHero = ({
    entidade,
    servico,
    formData,
    submitStatus,
    isLoading,
    handleChange,
    handleSubmit,
    setShowOfferModal
}) => {
    // Usa os blocos de conteúdo que vêm do backend. Se não houver, usa um array vazio.
    const contentBlocks = servico.content_blocks || [];

    const getYouTubeEmbedUrl = (url) => {
        if (!url) return '';
        try {
            const urlObj = new URL(url);
            const videoId = urlObj.searchParams.get('v');
            return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
        } catch (error) {
            return url; // Retorna a URL original se não for uma URL válida do YouTube
        }
    };

    const renderFormBlock = (block) => (
        <section id={`form-top-${block.formId}`} className={`lp-section d-flex justify-content-center ${block.sectionBgColor === '#f8f9fa' ? 'bg-light' : ''}`} style={{ backgroundColor: block.sectionBgColor }}>
            <Container className="container-no-margin-inherit center">
                <Row className="justify-content-center">
                    <Col lg={8}>
                        <Card className="p-4 border-0 shadow-lg">
                            <Card.Body>
                                {submitStatus.submitted ? (
                                    <Alert variant={submitStatus.variant} className="text-center">
                                        <Alert.Heading>{submitStatus.variant === 'success' ? 'Obrigado!' : 'Ops!'}</Alert.Heading>
                                        <p className="mb-0">{submitStatus.message}</p>
                                    </Alert>
                                ) : (
                                    <>
                                        <h3 className="text-center mb-1">{block.titulo || 'Comece sua transformação'}</h3>
                                        <p className="text-center text-muted mb-4">{block.descricao || 'Preencha o formulário para agendar sua avaliação.'}</p>
                                        <Form onSubmit={handleSubmit}>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text><FontAwesomeIcon icon="user" /></InputGroup.Text>
                                                <Form.Control type="text" name="nome" placeholder="Nome Completo" value={formData.nome} onChange={handleChange} required />
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text><FontAwesomeIcon icon="phone" /></InputGroup.Text>
                                                <Form.Control type="tel" name="telefone" placeholder="Telefone / WhatsApp" value={formData.telefone} onChange={handleChange} required />
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text><FontAwesomeIcon icon="envelope" /></InputGroup.Text>
                                                <Form.Control type="email" name="email" placeholder="Seu melhor e-mail" value={formData.email} onChange={handleChange} required />
                                            </InputGroup>
                                            <div className="d-grid">
                                                <Button variant="primary" type="submit" size="lg" disabled={isLoading}>
                                                    {isLoading 
                                                        ? <Spinner as="span" size="sm" /> 
                                                        : (servico && servico.redirect_url 
                                                            ? servico.texto_cta_principal || 'Acessar Oferta' 
                                                            : (entidade && entidade.whatsapp_funil ? 'Chamar no WhatsApp' : 'Enviar e Aguardar Contato')
                                                          )}
                                                </Button>
                                            </div>
                                        </Form> 
                                    </>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );

    const renderFaqBlock = (block) => (
        block.lista?.length > 0 && (
            <section className={`lp-section ${block.sectionBgColor === '#f8f9fa' ? 'bg-light' : ''}`} style={{ backgroundColor: block.sectionBgColor }}>
                <Container>
                    <h2 className="text-center mb-5">{block.titulo}</h2>
                    <Row className="justify-content-center">
                        <Col md={8}>
                            <Accordion>
                                {block.lista.map((faq, index) => (
                                    <Accordion.Item eventKey={String(index)} key={index}>
                                        <Accordion.Header>{faq.pergunta}</Accordion.Header>
                                        <Accordion.Body>{faq.resposta}</Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        </Col>
                    </Row>
                </Container>
            </section>
        )
    );

    const renderBeneficiosBlock = (block) => (
        block.lista?.length > 0 && (
            <section className={`lp-section ${block.sectionBgColor === '#f8f9fa' ? 'bg-light' : ''}`} style={{ backgroundColor: block.sectionBgColor }}>
                <Container>
                    <h2 className="text-center mb-5">{block.titulo}</h2>
                    <Row>
                        {block.lista.map((beneficio, index) => (
                            <Col md={4} key={index} className="mb-4 text-center">
                                <div className="display-4 mb-3">{beneficio.icone}</div>
                                <h5 className="fw-bold">{beneficio.titulo}</h5>
                                <p className="text-muted">{beneficio.descricao}</p>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        )
    );

    const renderAntesDepoisBlock = (block) => (
        block.imagens?.length > 0 && (
            <section className={`lp-section ${block.sectionBgColor === '#f8f9fa' ? 'bg-light' : ''}`} style={{ backgroundColor: block.sectionBgColor }}>
                <Container>
                    <h2 className="text-center mb-5">{block.titulo}</h2>
                    <Row className="g-2">
                        {block.imagens.map((img, index) => (
                            <React.Fragment key={index}>
                                <Col xs={6}><Image src={img.antes} fluid rounded /></Col>
                                <Col xs={6}><Image src={img.depois} fluid rounded /></Col>
                            </React.Fragment>
                        ))}
                    </Row>
                </Container>
            </section>
        )
    );

    const renderConteudoPrincipalBlock = (block) => (
        <section className={`text-center lp-section ${block.sectionBgColor === '#f8f9fa' ? 'bg-light' : ''}`} style={{ backgroundColor: block.sectionBgColor }}>
            <Container>
                <h1 className="display-5 fw-bold">{block.titulo}</h1>
                <p className="lead text-muted">{block.subtitulo}</p>
                {block.imagem_path && (
                    <div className="mt-4">
                        <Image src={block.imagem_path} fluid rounded />
                    </div>
                )}
            </Container>
        </section>
    );

    const renderOfertaBlock = (block) => (
        block.titulo && (
            <section className={`lp-section text-center ${block.sectionBgColor === '#f8f9fa' ? 'bg-light' : ''}`} style={{ backgroundColor: block.sectionBgColor }}>
                <Container>
                    <h2 className="fw-bold">{block.titulo}</h2>
                    {block.preco_antigo && block.preco_novo && (
                        <div className="price-tag-offer my-4 justify-content-center">
                            <span className="price-old">{block.preco_antigo}</span>
                            <span className="price-new">{block.preco_novo}</span>
                        </div>
                    )}
                    <p className="lead">{block.texto_urgencia}</p>
                    <Button variant="primary" size="lg" onClick={() => setShowOfferModal(true)}>
                        {block.texto_cta || 'Eu Quero Essa Oferta!'}
                    </Button>
                </Container>
            </section>
        )
    );




    return (
        <>
            {contentBlocks.map((block, index) => {
                const nextBlock = index < contentBlocks.length - 1 ? contentBlocks[index + 1] : null;
                const dividerColor = nextBlock ? nextBlock.sectionBgColor : '#FFFFFF'; // Cor do próximo bloco ou branco se for o último
                const sectionClassName = `lp-section ${block.sectionBgColor === '#f8f9fa' ? 'bg-light' : ''}`;
                let blockContent;
                switch (block.type) {
                    case 'image':
                        // --- LÓGICA DE IMAGEM RESPONSIVA ---
                        // Assume que o backend fornecerá `src_desktop` e `src_mobile`.
                        // Usa `block.src` como fallback para compatibilidade.
                        const srcDesktop = block.src_desktop?.url || block.src;
                        const srcMobile = block.src_mobile?.url || srcDesktop; // Se a imagem mobile não existir, usa a de desktop.

                        blockContent = (
                            <section className="p-0" style={{ backgroundColor: block.sectionBgColor }}>
                                <picture style={{ width: '100%' }}>
                                    {/* Imagem para telas mobile (até 767px de largura) */}
                                    <source media="(max-width: 767px)" srcSet={srcMobile} />
                                    {/* Imagem para telas desktop (768px ou mais) */}
                                    <source media="(min-width: 768px)" srcSet={srcDesktop} />
                                    {/* Imagem de fallback caso o navegador não suporte <picture> */}
                                    <img src={srcDesktop} alt={block.alt || 'Imagem do serviço'} className="img-fluid" style={{ width: '100%' }} />
                                </picture>
                            </section>
                        );
                        break;
                    case 'video':
                        blockContent = (
                            <section className={`lp-section d-flex justify-content-center ${block.sectionBgColor === '#f8f9fa' ? 'bg-light' : ''}`} style={{ backgroundColor: block.sectionBgColor }}>
                                <Container className="container-no-margin-inherit">
                                    <Row className="justify-content-center">
                                        <Col lg={8}>
                                            <div className="ratio ratio-16x9 shadow-lg rounded">
                                                <iframe src={getYouTubeEmbedUrl(block.src)} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                        );
                        break;
                    case 'form':
                        blockContent = renderFormBlock(block);
                        break;
                    case 'faq':
                        blockContent = renderFaqBlock(block);
                        break;
                    case 'conteudo_principal':
                        blockContent = renderConteudoPrincipalBlock(block);
                        break;
                    case 'oferta':
                        blockContent = renderOfertaBlock(block);
                        break;
                    case 'beneficios':
                        blockContent = renderBeneficiosBlock(block);
                        break;
                    case 'antes_depois':
                        blockContent = renderAntesDepoisBlock(block);
                        break;
                    case 'seo':
                        blockContent = null; // Bloco de SEO não tem renderização visual no corpo da página
                        break;
                    default:
                        blockContent = null;
                }

                return (
                    <React.Fragment key={block.id || index}>
                        {blockContent}
                        {index < contentBlocks.length - 1 && <ShapeDivider color={dividerColor} />}
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default TemplateVideoHero;
